import React, { Fragment } from 'react';

const Navigation = ({links=[], contentLink=null, level=0 }) => {
    let menuRef = React.createRef();
    function toggleMenu() {
        menuRef.current.classList.toggle('navbar__menu--show');
    }
    const additionClass = contentLink && contentLink.attributes ? contentLink.attributes.cssValue : null;
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = link => link.name || (link.links || []).length > 0;
    const isAutoColumnMenu = (isOverColumn, level) => {
        if(level !== 0) return '';
        return isOverColumn ? ' column-menu' : ' regular-menu';
    };
    const currentLevel = level;

    function isActive(contentLink){
        if(contentLink!=null)
        {
            if(contentLink.isSelected==true)
            {
                return true;
            }
            else{
                return false;
            }
        }
        return false;
    }
    return (
    <Fragment>
        {!contentLink ? (
            <a className="navbar__link--block navbar__icon--menu navbar__icon" onClick={toggleMenu}> 
                <svg>
                    <use href="/ui/images/sprites/be-group.svg#menu"></use>
                </svg>
            </a>
        ) : (
            <Fragment>
                { contentLink.columnImageSrc &&
                    <img className="navbar__column-image" src={contentLink.columnImageSrc}></img>
                }

                <a className={`navbar__link navbar__link--level-${currentLevel} ${hasChildrenClass || '' } ${additionClass || ''}`} 
                    href={contentLink.url||'#'} 
                    dangerouslySetInnerHTML={{__html: contentLink.name}} 
                    target={contentLink.isExternalLink ? '_blank' : '_self'}>
                </a>
                {links.length > 0 &&
                    <a className="menu-btn menu-btn--open" onClick={toggleMenu}>
                        <svg className="menu-btn__icon">
                            <use href="/ui/images/sprites/be-group.svg#arrow"></use>
                        </svg>
                    </a>
                }
            </Fragment>
        )}

        { links.length > 0 &&
            <div className={isActive(contentLink)? 'navbar__menu  navbar__level-'+currentLevel +' navbar__menu--show': 'navbar__menu  navbar__level-'+currentLevel} ref={menuRef}>
                   
                <div className="navbar__menu-header mobile-menu-header">
                    {!contentLink ? (
                        <a className="menu-btn menu-btn--close" onClick={toggleMenu}>
                            <svg className="menu-btn__icon">
                                <use href="/ui/images/sprites/be-group.svg#cross"></use>
                            </svg>
                        </a>
                    ) : (<Fragment>
                            <a className="menu-btn menu-btn--arrow" onClick={toggleMenu}>
                                <svg className="menu-btn__icon">
                                    <use href="/ui/images/sprites/be-group.svg#arrow"></use>
                                </svg>
                            </a>
                            <span className={'navbar__title' + (currentLevel === 1 ? ' h2 header-decorated' : '')} onClick={toggleMenu} dangerouslySetInnerHTML={{__html: contentLink.name}}></span>
                        </Fragment>)}
                </div>

                <ul>
                    {links.length > 0 && links.filter(l => hasNameOrChildren(l)).map((link, i) =>
                        <Fragment key={`optionnav-${i}-${link.name}-${currentLevel}`}>
                            <li className={'navbar__item' + (link.isSelected ? ' active': '') + isAutoColumnMenu(link.isOverColumn, currentLevel)} key={`${link.name}-${i}-${currentLevel}`}>
                                <Navigation links={link.links} contentLink={link} level={currentLevel + 1} />
                            </li>
                        </Fragment>
                    )}
                </ul>
            </div>
        }
        
    </Fragment>
)}

export default Navigation;